'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'door-open';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f52b';
var svgPathData = ['M48 64l0 432 256 0 0-432c0-26.5-21.5-48-48-48L96 16C69.5 16 48 37.5 48 64zM192 256c0-4.4 .9-8.6 2.5-12.5 .4-.9 .9-1.9 1.4-2.8 .5-.8 1-1.7 1.6-2.6 1.2-1.7 2.5-3.3 3.9-4.8 5.8-5.8 13.8-9.4 22.6-9.4 8.9 0 16.9 3.6 22.7 9.5 1.5 1.5 2.8 3.1 3.9 4.8 1 1.5 2 3.3 2.8 5.3 1.6 3.9 2.5 8.1 2.5 12.5 0 4.4-.9 8.6-2.5 12.5-.8 2-1.8 3.8-2.9 5.4-1.2 1.7-2.5 3.3-3.9 4.8-5.8 5.8-13.8 9.4-22.6 9.4-8.9 0-16.9-3.6-22.7-9.5-1.4-1.5-2.7-3.1-3.9-4.8-.5-.8-1-1.6-1.5-2.4-.5-1-1-1.9-1.4-2.8-1.6-3.8-2.5-8-2.5-12.5z', 'M96 16l160 0c26.5 0 48 21.5 48 48l0 432-256 0 0-432c0-26.5 21.5-48 48-48zm202.3 0L352 16c26.5 0 48 21.5 48 48l0 440c0 4.4 3.6 8 8 8l32 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-24 0 0-432c0-35.3-28.7-64-64-64L96 0C60.7 0 32 28.7 32 64l0 432-24 0c-4.4 0-8 3.6-8 8s3.6 8 8 8l312 0 0-448c0-19.1-8.4-36.3-21.7-48zM240 256a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDoorOpen = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;